<template>
  <div>
    <el-row style="margin-bottom: 20px">
      <el-col>
        <el-button type="primary" size="small"  @click="getPrint">获取打印机</el-button>
        <el-select id="plist" v-model="printName" size="small" style="width: 280px" placeholder="请选择">
          <el-option
            v-for="item in printerList"
            :key="item.name"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
        <el-button type="primary" size="small"  @click="print('preview')">预览</el-button>
        <el-button type="primary" size="small"  @click="print">打印</el-button>
        <el-button type="primary" size="small"  @click="getConfig">获取打印机配置</el-button>
        <el-select id="plist" v-model="operate" size="small" style="width: 100px" placeholder="请选择">
          <el-option
            v-for="item in memoOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="memo" size="small" style="width: 160px"></el-input>
        <el-select id="db" v-model="db" size="small" style="width: 100px" placeholder="请选择">
          <el-option
            v-for="item in dbOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" size="small"  @click="getGaoDengData">搜索</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" ref="multipleTable"
                  :data="gaodengData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column
            type="selection"
            width="45">
          </el-table-column>
          <el-table-column  prop="buyerNick" label="买家ID" width="120px"></el-table-column>
          <el-table-column  prop="kd" label="发货说明"  width="80px"></el-table-column>
          <el-table-column  prop="shortName" label="简称" width="100px"></el-table-column>
          <el-table-column  prop="color" label="颜色" width="180px"></el-table-column>
          <el-table-column  prop="num" label="数量" width="80px"></el-table-column>
          <el-table-column  prop="buyerMessage" label="买家留言" ></el-table-column>
          <el-table-column  prop="sellerMemo" label="卖家备注" ></el-table-column>
          <el-table-column  prop="teShu" label="说明" width="80px"></el-table-column>
          <el-table-column  prop="payTime" label="付款时间" width="160px"></el-table-column>
          <el-table-column  prop="receiverState" label="收货地" width="80px"></el-table-column>
        </el-table>

      </el-col>
    </el-row>

    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100, 5000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>

    <el-dialog
      title="打印预览"
      :visible.sync="showPreview"
      width="550px"
      center>
      <img width="500px" height="350px" :src="this.imgUrl"/>
      <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="showPreview=false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

    export default {
        name: "GaoDeng",
      data(){
          return{
            socket:'',
            printName:'',
            defaultPrinter:'',
            printerList:[],
            showPreview:false,
            imgUrl:'',
            gaodengData:[],
            memo:'',
            operate:'>0',
            memoOpto:[{value: '>0', label: '有备注'},{value: '=0', label: '无备注'}],
            db:'0',
            dbOpto:[{value: '0', label: '订单表'},{value: '1', label: '打单表'}],
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 10
            },
          }
      },
      methods:{
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getGaoDengData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getGaoDengData();
        },
        dateFormat:function (fmt, date) {
            let ret;
            let opt = {
              "Y+": date.getFullYear().toString(),        // 年
              "m+": (date.getMonth() + 1).toString(),     // 月
              "d+": date.getDate().toString(),            // 日
              "H+": date.getHours().toString(),           // 时
              "M+": date.getMinutes().toString(),         // 分
              "S+": date.getSeconds().toString()          // 秒
              // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
              ret = new RegExp("(" + k + ")").exec(fmt);
              if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
              };
            };
            return fmt;
          },
        connect:function(){
           let  serverUrl='ws://localhost:13528';
           if(typeof(WebSocket) === "undefined"){
             alert("您的浏览器不支持socket")
           }else{
             // 实例化socket
             this.socket = new WebSocket(serverUrl);
             // 监听socket连接
             this.socket.onopen = this.open;
             // 监听socket错误信息
             this.socket.onerror = this.error;
             // 监听socket消息
             this.socket.onmessage = this.getMessage;
           }
        },
        open: function () {
          console.log("socket连接成功");
          this.getPrint();
        },
        error: function () {
          console.log("连接错误")
        },
        getMessage: function (obj) {
          console.log(obj.data);
          let data = JSON.parse(obj.data);
          if (data.cmd == "getPrinters") {
            this.printerList = data.printers;
            this.printName = data.defaultPrinter;
          }else if (data.cmd == "getPrinterConfig") {
            alert(obj.data);
          }
          if (data.previewImage) {
            this.imgUrl = data.previewImage;
            this.showPreview=true;
          }
        },
        send: function () {
          this.socket.send(params)
        },
        close: function () {
          console.log("socket已经关闭")
        },
        getRequestObject: function (cmd) {
          let request = new Object();
          let time = new Date().getTime();
          request.requestID=time.toString();
          request.version="1.0";
          request.cmd=cmd;
          return request;
        },

        getPrint: function () {
          let request = this.getRequestObject("getPrinters");
          this.socket.send(JSON.stringify(request));
        },
        getConfig: function () {
          let request = this.getRequestObject("getPrinterConfig");
          console.log(this.printName);
          request.printer = this.printName;
          this.socket.send(JSON.stringify(request));
        },
        print:function (value) {
          let request = this.getRequestObject("print");
          request.task = new Object();
          request.task.taskID = request.requestID + "_TASK_0";
          if (value == "preview") {
            request.task.preview = true;
            request.task.previewType = "image";
          } else {
            request.task.preview = false;
          }
          request.task.printer = this.printName;
          let documents = new Array();
          const selectData = this.$refs.multipleTable.selection;
          console.log(selectData.length);
          for(let i=0;i<selectData.length;i++){
            let row = selectData[i];
            console.log(row);

            let doc = new Object();
            doc.documentID = i;
            let contents = new Array();
            let content = new Object();
            content.templateURL = "http://cloudprint.cainiao.com/template/standard/300224/21";
            let trade = new Object();
            let kd = '(顺丰)';
            //trade.buyer_nick = row.buyerNick + row.kd;
            trade.buyer_nick = row.tid.substr(-6)+row.buyerNick.replaceAll('*','');
            trade.tid = row.tid;
            trade.mobile =  row.receiverMobile.replaceAll('*','');
            trade.short_name = row.shortName;
            trade.propertity_name = row.color;
            trade.num = row.num;
            trade.buyer_message = row.buyerMessage;
            trade.seller_memo = row.sellerMemo;
            trade.tushu = '';
            let time2 = new Date(row.payTime);
            trade.pay_time = this.dateFormat("m/d HH:MM", time2);
            trade.pay_day = this.dateFormat("d ", time2);
            content.data = trade;
            contents.push(content);
            doc.contents = contents;
            documents.push(doc);
            if (value == "preview")
              break;
          }
          request.task.documents = documents;
          console.log(JSON.stringify(request))
          this.socket.send(JSON.stringify(request));
        },



        getGaoDengData:function () {
          let param={
            nick: storage.get("nick"),
            memo:this.memo,
            operate:this.operate,
            db:this.db,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/custom/gaodeng", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.gaodengData = dataResult.data.gaodeng;

              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
              this.$message.success("获取订单数据成功！");
            }
            else{
              this.$message.error(dataResult.message);
              this.$router.replace({name: "Index"});
            }

          })

        }
      },
      mounted() {

        this.getGaoDengData();
        this.connect();
      }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/custom/GaoDeng.vue